import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Snackbar, TextField } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { useMutation, queryCache } from 'react-query';
import { formatCurrency } from '@brazilian-utils/brazilian-utils';
import { useAuth } from '../../../../../auth/authProvider';
import partnershipRequest from '../../../../../services/network/partnershipRequest';

export const AlterarValorParcelaDialog = props => {
  const { show, onClose, data, refetchInvoices } = props;
  const { token } = useAuth();
  const [alert, setAlert] = useState({ show: false, msg: '' });
  const [valor, setValor] = useState({ texto: '', numero: 0, erro: '' });

  useEffect(() => {
    if (show && data?.valorParcela) {
      setValor({
        texto: formatCurrency(data.valorParcela),
        numero: data.valorParcela,
        erro: '',
      });
    }
  }, [show, data]);

  const [alterarValorParcela] = useMutation(
    () =>
      partnershipRequest.patch(
        `invoices/partner-invoice-comissioning-lead/${data?.paymentId}`,
        { installmentAmount: valor.numero },
        { token },
      ),
    {
      onSuccess: () => {
        setAlert({ show: true, msg: 'Alterações realizadas com sucesso' });
        onClose();
        queryCache.refetchQueries('fetch-payments');
        if (refetchInvoices) {
          refetchInvoices();
        }
      },
      onError: error => {
        setAlert({ show: true, msg: error.message || 'Erro ao salvar' });
      },
    },
  );

  const handleInputChange = e => {
    const numericOnly = e.target.value.replace(/\D/g, '');

    if (!numericOnly) {
      setValor({ texto: '', numero: 0, erro: 'O valor deve ser maior que zero' });
      return;
    }

    const valorEmReais = parseInt(numericOnly, 10) / 100;
    const formatted = formatCurrency(valorEmReais);

    setValor({
      texto: formatted,
      numero: valorEmReais,
      erro: valorEmReais <= 0 ? 'O valor deve ser maior que zero' : '',
    });
  };

  return (
    <>
      <Dialog open={show} onClose={onClose}>
        <DialogTitle>Editar valor da parcela</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            variant="outlined"
            value={valor.texto}
            onChange={handleInputChange}
            error={!!valor.erro}
            helperText={valor.erro}
            placeholder={formatCurrency(data?.valorParcela || 0)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            CANCELAR
          </Button>
          <Button color="primary" onClick={alterarValorParcela} disabled={!!valor.erro || valor.numero <= 0}>
            SALVAR
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={alert.show}
        autoHideDuration={6000}
        message={alert.msg}
        onClose={() => setAlert({ show: false, msg: '' })}
      />
    </>
  );
};
